import * as countries from "i18n-iso-countries";





export function alpha3ToAlpha2(alpha3?: string): string | null {
    if (!alpha3) return null;

    const a3 = alpha3.trim().toUpperCase();
    if (a3 === "ARG") return "ar";
    if (a3 === "CZE") return "cz";
    if (a3 === "DNK") return "dk";
    if (a3 === "ESP") return "es";
    if (a3 === "FRA") return "fr";
    if (a3 === "GER") return "de";
    if (a3 === "IMN") return "im";
    if (a3 === "ISR") return "il";
    if (a3 === "ITA") return "it";
    if (a3 === "JPN") return "jp";
    if (a3 === "KAZ") return "kz";
    if (a3 === "RUS") return "ru";
    if (a3 === "SWE") return "se";
    if (a3 === "USA") return "us";
    if (a3 === "UZB") return "uz";
    if (a3 === "KEN") return "ke";
    if (a3 === "ETH") return "et";
    if (a3 === "GBR") return "gb";
    if (a3 === "CAN") return "ca";
    if (a3 === "CRO") return "hr";
    if (a3 === "POL") return "pl";
    if (a3 === "NED") return "nl";
    if (a3 === "BRA") return "br";
    if (a3 === "BUL") return "bg";
    if (a3 === "UKR") return "ua";
    if (a3 === "HUN") return "hu";
    if (a3 === "MDA") return "md";
    if (a3 === "CHE") return "ch";
    if (a3 === "BEL") return "be";
    if (a3 === "NOR") return "no";
    if (a3 === "MEX") return "mx";
    if (a3 === "GEO") return "ge";
    if (a3 === "ZAF") return "za";
    if (a3 === "CHN") return "cn";
    if (a3 === "PHI") return "ph";
    if (a3 === "AUS") return "au";
    if (a3 === "DZA") return "dz";
    if (a3 === "IRN") return "ir";
    if (a3 === "EGY") return "eg";
    if (a3 === "IRL") return "ie";
    if (a3 === "SGP") return "sg";
    if (a3 === "POR") return "pt";
    if (a3 === "BLR") return "by";

    return 'il';
}
